import { createStyles, makeStyles } from '@material-ui/core/styles'

export const useStyles = makeStyles(({ palette }) =>
  createStyles({
    row: {
      cursor: 'pointer',
      '& td': {
        backgroundColor: palette.background.default,
        borderBottom: '0px solid ' + palette.divider,
        padding: '1.2rem 0.5rem',
        maxWidth: 0,
        '&:first-child': {
          color: 'var(--text-title)',
          borderTopLeftRadius: 5,
          borderBottomLeftRadius: 5,
          paddingLeft: '2rem',
        },
        '&:nth-child(2), &:nth-child(4)': {
          '& > .MuiTypography-subtitle1': {
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
          },
        },

        '&:last-child': {
          borderTopRightRadius: 5,
          borderBottomRightRadius: 5,
        },
      },
    },
    statusCell: {
      '& > div': {
        display: 'flex',
        justifyContent: 'flex-start',
        alignItems: 'center',
        gap: '0.8rem',
        height: '2.3rem',
        padding: '0 0.8rem',
        marginRight: '2.4rem',
        color: '#ffffff',
        fontSize: '1.2rem',
        borderRadius: '5px',
        '& > span': {
          display: 'flex',
          alignItems: 'center',
          '& svg': {
            width: '1.4rem',
            height: '1.6rem',
          },
        },
      },
    },
    greenLabel: {
      backgroundColor: '#A0C84B',
      zIndex: 1,
      position: 'relative',
    },
    orangeLabel: {
      backgroundColor: '#FAAF32',
      zIndex: 1,
      position: 'relative',
    },
    redLabel: {
      backgroundColor: '#E64B32',
      zIndex: 1,
      position: 'relative',
    },
  }),
)
